import React, { useEffect, useState } from "react";
import axios from "axios";

const API_BASE = process.env.REACT_APP_PUBLIC_API_BASE;

const getTokenFromUrl = () => {
  const params = new URLSearchParams(window.location.search);
  return params.get("token") || "";
};

function App() {
  const [token, setToken] = useState(getTokenFromUrl());
  const [customer, setCustomer] = useState(null);
  const [packages, setPackages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [uploading, setUploading] = useState({});

  const loadPackages = async (tokenValue) => {
    setLoading(true);
    setError("");
    try {
      const response = await axios.get(`${API_BASE}/invoices`, {
        params: { token: tokenValue }
      });
      setCustomer(response.data.customer);
      setPackages(response.data.packages || []);
    } catch (err) {
      const message = err.response?.data?.message || err.message;
      console.log(err)
      setError(message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (token) {
      loadPackages(token);
    }
  }, [token]);

  const handleUpload = async (packageId, files) => {
    if (!files || files.length === 0) return;

    const formData = new FormData();
    Array.from(files).forEach((file) => formData.append("invoices", file));

    setUploading((prev) => ({ ...prev, [packageId]: true }));
    try {
      await axios.post(`${API_BASE}/invoices/${packageId}/upload`, formData, {
        params: { token },
        headers: { "Content-Type": "multipart/form-data" }
      });
      await loadPackages(token);
    } catch (err) {
      const message = err.response?.data?.message || err.message;
      setError(message);
    } finally {
      setUploading((prev) => ({ ...prev, [packageId]: false }));
    }
  };



  return (
    <div className="page">
      <div className="card">
        <h1>Ship For Less</h1>
        <h3>Invoice Submission Portal</h3>
      </div>
      {!token &&
        <div className="card">
          <h4 className="error">Error: {error}</h4>
        </div>
      }
      {token && <div className="card">
        {customer && (
          <h2 className="greeting">
            Hello {customer.firstName},
          </h2>
        )}{!loading && packages.length > 0 && !error && (<p>Kindly upload the invoice(s) to ensure timely customs clearance and processing.</p>)}
        {loading && <p>Loading packages...</p>}
        {error && <p className="error">{error}</p>}
        {!loading && packages.length === 0 && !error && (
          <p>No packages pending invoice upload.</p>
        )}
        <div className="package-list">
          {packages.map((pkg) => (
            <div key={pkg._id} className="package-item">
              <div className="package-info">
                <div className="tracking">{pkg.trackingNo.length > 14 ? pkg.trackingNo.slice(0, 7) + "***" + pkg.trackingNo.slice(-7) : pkg.trackingNo}</div>
                <div className="meta">{pkg.origin}</div>
                <div className="meta">{pkg.description}</div>
              </div>
              <div className="package-actions">
                <label className="upload-button">
                  {uploading[pkg._id] ? "Uploading..." : "Upload Invoices"}
                  <input
                    type="file"
                    multiple
                    accept="application/pdf,image/jpeg,image/png"
                    onChange={(e) => handleUpload(pkg._id, e.target.files)}
                    disabled={uploading[pkg._id]}
                  />
                </label>
              </div>
            </div>
          ))}
        </div>
      </div>}
      <div className="footerCard">
        <p className="footer">{new Date().getFullYear()} © CODExNETWORK IT SOLUTIONS</p>
        <p className="footer">SHIP FOR LESS JAMAICA LIMITED</p>
      </div>
    </div >
  );
}

export default App;
